export const NAVIGABLE_PAGE_IDS = new Set([
  "home", "business", "dashboard", "journal", "decisions", "adviser",
  "planning", "financial_memory", "family", "family_planning",
  "family_planning_members", "family_planning_goals",
  "family_planning_retirement", "family_planning_assumptions", "tax_history",
  "relationships", "travel", "income", "money", "spending", "statements",
  "transactions", "manual_entries", "statement_imports", "financial_statements",
  "investment_journey", "investment_performance", "rewards", "cashflow", "rules",
  "accounts", "mappings", "import", "sectors", "alerts", "sync",
  "debt_retirement", "assets", "dividends", "ideas", "momentum_strategy",
  "momentum_analysis", "momentum_sleeve", "us_momentum_analysis", "networth",
  "crypto", "funds_intel",
]);

export function pageFromSearch(search = "") {
  const requestedPage = new URLSearchParams(search).get("page");
  return NAVIGABLE_PAGE_IDS.has(requestedPage) ? requestedPage : "home";
}

export function urlForPage(page, location = window.location) {
  const params = new URLSearchParams(location.search);
  if (page === "home") params.delete("page");
  else params.set("page", page);
  const search = params.toString();
  return `${location.pathname}${search ? `?${search}` : ""}${location.hash || ""}`;
}
